/**
 * Created by Tiger on 22/02/2022.
 */
import React from 'react';
import Styles from './css/ConfigHeader.module.scss';
import {Button} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import i18n from 'i18next';


export default function ConfigHeader(props) {

  return <div className={ Styles.container }>
    <Button icon={ <PlusOutlined/> } type="primary" onClick={ props.addConfig }>{ i18n.t('add') }</Button>
  </div>;
}
